import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Skull, BadgeDollarSign } from "lucide-react";

export const PricingStrip = () => {
    return (
        <section className="pp-bg-0 py-12" data-testid="pricing-cta-strip">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <div className="rounded-2xl pp-bg-1 border border-[#242436] p-6 sm:p-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6" style={{ boxShadow: "0 0 0 1px rgba(111,63,236,0.25), 0 0 36px rgba(111,63,236,0.18)" }}>
                    <div>
                        <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#0a1f0e] border border-[#22c55e]66 text-[10px] font-mono uppercase tracking-widest text-[#22c55e] mb-2" data-testid="pricing-strip-cheap-tag">
                            <BadgeDollarSign className="w-3 h-3" /> Cheapest lock-in service in the game
                        </span>
                        <p className="text-xs font-mono uppercase text-[#a855f7] tracking-widest">Ready to ride?</p>
                        <h3 className="mt-1 font-display text-2xl sm:text-4xl tracking-wider text-white">UNLOCK THE DEMON CARDS</h3>
                        <p className="mt-2 text-sm text-[#b7b7c6] max-w-xl">Pro picks at <span className="text-white font-semibold">$13/week</span> — under $2/day. Sports Premium adds the high-risk demon plays at <span className="text-white font-semibold">$23/week</span>. Cancel anytime, no Discord, no upsells.</p>
                    </div>
                    <Button asChild className="bg-[#6f3fec] hover:brightness-110 text-white h-12 px-6" data-testid="strip-pricing-cta">
                        <Link to="/pricing" className="inline-flex items-center gap-2">
                            <Skull className="w-4 h-4" /> See Plans <ArrowRight className="w-4 h-4" />
                        </Link>
                    </Button>
                </div>
            </div>
        </section>
    );
};
